import PropTypes from 'prop-types';
// material-ui
import { useTheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse }) {
  const theme = useTheme();
  const textColor = theme.palette.mode === ThemeMode.DARK || reverse ? theme.palette.common.white : theme.palette.common.black;

  return (
    <svg width="118" height="42" viewBox="0 0 118 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="lm-gradTop" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={theme.palette.primary.light} />
          <stop offset="100%" stopColor={theme.palette.primary.main} />
        </linearGradient>
        <linearGradient id="lm-gradSide" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={theme.palette.primary.main} />
          <stop offset="100%" stopColor={theme.palette.primary.darker} />
        </linearGradient>
        <filter id="lm-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="2" stdDeviation="2" floodOpacity="0.25" />
        </filter>
      </defs>

      {/* Icono isométrico escalado para encajar en ~24×30px */}
      <g transform="scale(0.238) translate(-55, -25)">
        {/* Sombra base */}
        <ellipse cx="110" cy="185" rx="60" ry="12" fill="#000" opacity="0.15" />

        {/* Panel 4 (más bajo) */}
        <g transform="translate(0, 36)">
          <polygon points="60,100 110,80 160,100 110,120" fill="url(#lm-gradTop)" />
          <polygon points="60,100 60,120 110,140 110,120" fill="url(#lm-gradSide)" />
          <polygon points="160,100 160,120 110,140 110,120" fill={theme.palette.primary.dark} />
          <circle cx="65" cy="100" r="3" fill={theme.palette.info.main} />
          <circle cx="155" cy="100" r="3" fill={theme.palette.info.main} />
          <circle cx="65" cy="120" r="3" fill={theme.palette.info.light} />
          <circle cx="155" cy="120" r="3" fill={theme.palette.info.light} />
        </g>

        {/* Panel 3 */}
        <g transform="translate(0, 24)">
          <polygon points="60,90 110,70 160,90 110,110" fill="url(#lm-gradTop)" />
          <polygon points="60,90 60,110 110,130 110,110" fill="url(#lm-gradSide)" />
          <polygon points="160,90 160,110 110,130 110,110" fill={theme.palette.primary.dark} />
          <circle cx="65" cy="90" r="3" fill={theme.palette.info.main} />
          <circle cx="155" cy="90" r="3" fill={theme.palette.info.main} />
          <circle cx="65" cy="110" r="3" fill={theme.palette.info.light} />
          <circle cx="155" cy="110" r="3" fill={theme.palette.info.light} />
        </g>

        {/* Panel 2 */}
        <g transform="translate(0, 12)">
          <polygon points="60,80 110,60 160,80 110,100" fill="url(#lm-gradTop)" />
          <polygon points="60,80 60,100 110,120 110,100" fill="url(#lm-gradSide)" />
          <polygon points="160,80 160,100 110,120 110,100" fill={theme.palette.primary.dark} />
          <circle cx="65" cy="80" r="3" fill={theme.palette.info.main} />
          <circle cx="155" cy="80" r="3" fill={theme.palette.info.main} />
          <circle cx="65" cy="100" r="3" fill={theme.palette.info.light} />
          <circle cx="155" cy="100" r="3" fill={theme.palette.info.light} />
        </g>

        {/* Panel superior */}
        <g filter="url(#lm-shadow)">
          <polygon points="60,70 110,50 160,70 110,90" fill="url(#lm-gradTop)" />
          <polygon points="60,70 60,90 110,110 110,90" fill="url(#lm-gradSide)" />
          <polygon points="160,70 160,90 110,110 110,90" fill={theme.palette.primary.dark} />
          <circle cx="65" cy="70" r="3" fill={theme.palette.info.main} />
          <circle cx="155" cy="70" r="3" fill={theme.palette.info.main} />
          <circle cx="65" cy="90" r="3" fill={theme.palette.info.light} />
          <circle cx="155" cy="90" r="3" fill={theme.palette.info.light} />
          {/* Líneas y texto decorativo #FMR */}
          <g transform="rotate(-28 110 72)">
            <line
              x1="86"
              y1="60"
              x2="124"
              y2="63"
              stroke={theme.palette.primary[100]}
              strokeWidth="2"
              strokeLinecap="round"
              opacity="0.6"
            />
            <text
              x="110"
              y="74"
              textAnchor="middle"
              fill={theme.palette.common.white}
              fontSize="9"
              fontFamily="monospace"
              fontWeight="600"
              opacity="0.9"
            >
              #FMR
            </text>
            <line
              x1="100"
              y1="79"
              x2="138"
              y2="82"
              stroke={theme.palette.primary[100]}
              strokeWidth="2"
              strokeLinecap="round"
              opacity="0.6"
            />
          </g>
        </g>
      </g>

      {/* Texto SIAF */}
      <text x="44" y="31" fontFamily="Arial, Helvetica, sans-serif" fontSize="26" fontWeight="bold" fill={textColor} fillOpacity="0.85">
        SIAF
      </text>
    </svg>
  );
}

LogoMain.propTypes = { reverse: PropTypes.bool };
